<template>
	<div 
		class="file-box"
		:class="[
			!file.is_available ? 'not-available' : ''
		]"
		v-if="!file.should_delete"
		>
		<div class="left-side">
			<div class="icon">
				<!-- <img src="/images/icons/file-green.svg" /> -->
				<i class="fal fa-file"></i>
			</div>
			<div class="file-info">
				<div class="file-name">
					{{ truncateIfBig(file.file_name) }}
				</div>
				<div class="file-size">
					{{ humanFileSize(file.size) }} 
				</div>
			</div>
		</div>
		<div class="right-side">

			<strong v-if="!file.is_available">
				Processing
			</strong>
			<span v-else>
				Uploaded on {{ new Date(file.created_at).toLocaleDateString() }}
			</span>
		</div>

		<a :href="`/download/${base64Encode(file.id)}`" v-if="file.is_available && canDownload" target="_blank" class="link"></a>
		<div 
			class="mark-as-backed-up"
			v-if="canMarkAsBackedUp === true"
			@click="markAsBackedUp"
			>
			<template v-if="file.backed_up">
				<div class="tick-box ticked" />
				File is marked as backed up
			</template>
			<template v-else>
				<div class="tick-box" />
				Mark as backed up
			</template>
		</div>
	</div>
</template>

<script>

export default {
	props: [
		'file',
		'admin',
		'canDownload',
		'canMarkAsBackedUp'
	],
	methods: {
		humanFileSize(payload) {
			let fileSize = ''
			let size = parseInt(payload)

			if (size >= 1073741824) {
				fileSize = this.round(size / 1024 / 1024 / 1024, 1) + ' GB'
			} else if (size >= 1048576) {
				fileSize = this.round(size / 1024 / 1024, 1) + ' MB'
			} else if(size >= 1024) {
				fileSize = this.round(size / 1024, 1) + ' KB'
			} else {
				fileSize = size + ' bytes'
			}
			return fileSize
		},
		round(value, precision) {
			let multiplier = Math.pow(10, precision || 0);
			return Math.round(value * multiplier) / multiplier;
		},
		base64Encode(string){
			let value = String(string)
			if (process.client) {
				return window.btoa(unescape(encodeURIComponent(value)))
			} else {
				return Buffer.from(value, 'ascii').toString('base64')
			}
		},
		truncateIfBig(string){
			if(string.length > 30){
				let splitString = string.split('.')
				let fileExt = splitString[splitString.length - 1]

				return string.slice(0, 30)+' ... .'+fileExt
			}else{
				return string
			}
		},
		markAsBackedUp(){
			if(!this.file.backed_up){
				this.$inertia.post(`/mark-file-as-backed-up/${this.file.id}`)
			}else{
				alert('This file is already marked as backed up.')
			}
		}
	},
	computed: {
		
	}
}

</script>

<style scoped lang="sass">


.file-box
	width: 100%
	background-color: #E0F5DD
	border-radius: 8px
	padding: 25px 30px
	display: flex
	align-items: flex-end
	justify-content: space-between
	color: #3E8732
	gap: 20px
	position: relative

	@media (max-width: 768px)
		flex-direction: column
		padding: 15px 20px
		gap: 10px

	&.not-available
		background-color: #EDC7B7
		color: #602E2B

	.link
		position: absolute
		top: 0
		left: 0
		right: 0
		bottom: 0
		display: block
		z-index: 10
		transition: all 300ms
		border-radius: 8px

		&:hover
			background-color: rgba(#fff, 0.1)
			text-decoration: none

	.left-side
		display: flex
		align-items: center
		gap: 20px

		@media (max-width: 768px)
			flex-direction: row
			width: 100%
			gap: 12px

		.icon
			width: 30px
			height: 40px
			display: flex
			align-items: center

			img
				max-height: 100%
				height: auto
				width: 100%

			.fal
				font-size: 40px

			@media (max-width: 768px)
				width: 20px
				height: 30px

				.fal
					font-size: 30px

		.file-info
			display: flex
			flex-direction: column

			@media (max-width: 768px)
				font-size: 12px

			.file-size
				font-weight: 700
				text-align: left

			.file-name
				width: 100%
				white-space: nowrap
				overflow: hidden
				text-overflow: ellipsis

				@media (max-width: 768px)
					max-width: 60vw

	.right-side
		font-size: 14px
		font-family: 'Roboto Condensed', sans-serif

		@media (max-width: 768px)
			width: 100%

	.mark-as-backed-up
		display: flex
		align-items: center
		gap: 8px
		font-size: 15px
		font-weight: 700
		position: absolute
		z-index: 11
		top: 5px
		right: 5px
		background-color: rgba(#fff, 0.5)
		border-radius: 3px
		padding: 4px 8px
		cursor: pointer
		transition: all 300ms

		&:hover
			background-color: rgba(#fff, 0.9)

		.tick-box
			width: 18px
			height: 18px
			border: 2px solid #3E8732
			border-radius: 3px
			background-color: #fff

			&.ticked

				&:after
					content: ''
					display: block
					width: 6px
					height: 10px
					border: solid #3E8732
					border-width: 0 2px 2px 0
					transform: rotate(45deg)
					position: relative
					top: 1px
					left: 4px

</style>